import { useAuth } from './authContext'
import { useI18n } from '../i18n'
import { Button } from '../components/Button'
import { Logo } from '../components/Logo'
import { useThemeColor } from '../hooks/StatusBarColorPicker'

/**
 * Public signed-out landing (route `/signed-out`). Logout redirects here so the
 * user reaches an intentional signed-out state with a Sign in button, instead of
 * bouncing back into the Keycloak login via `/` → `/home` → RequireAuth.
 */
export function SignedOut() {
  useThemeColor('#FFFFFF')
  const { login } = useAuth()
  const { t } = useI18n()

  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-6 bg-white p-6 text-center">
      <Logo width={72} height={27} />
      <p className="text-sm text-gray-700">{t('auth.signedOut')}</p>
      <Button onClick={login}>{t('auth.login')}</Button>
    </div>
  )
}
